export default "__VITE_ASSET__DGTUzaAJ__"